import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewChecked, ComponentFactoryResolver, ViewContainerRef, Injector, ApplicationRef, EmbeddedViewRef } from '@angular/core';

import swal from 'sweetalert2';
import * as shortid from 'shortid';
import { VideoLinkUploadModalComponent } from '../video-link-upload-modal/video-link-upload-modal.component';
import { EventService } from '../../services/event/event.service';

@Component({
  selector: 'app-video-upload-btn',
  templateUrl: './video-upload-btn.component.html',
  styleUrls: ['./video-upload-btn.component.css']
})
export class VideoUploadBtnComponent implements OnInit, AfterViewChecked {

  @ViewChild('closeLinkUploadModal') public closeLinkUploadModal: ElementRef;

  @Input() onlyFile = false;

  @Output() fileUpload = new EventEmitter();
  @Output() linkUpload = new EventEmitter();

  public data = {
    name: '',
    link: ''
  };
  public uniqueId = shortid.generate();

  private linkUploadModalInstance = null;
  private domElem = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef,
    private event: EventService
  ) { }

  ngOnInit() {
    this.event.on('videoLinkUpload', (data) => {
      this.linkUpload.emit(data);
    })
  }

  ngAfterViewChecked() {
    $('#linkUploadModal').on('hidden.bs.modal', () => {
      this.data = {
        name: '',
        link: ''
      };
      this.linkUploadModalInstance = null;
      document.body.removeChild(this.domElem);
    })
  }

  loadLinkUploadModal() {
    if (!this.linkUploadModalInstance) {
      const componentRef = this.componentFactoryResolver
        .resolveComponentFactory(VideoLinkUploadModalComponent)
        .create(this.injector);
      this.appRef.attachView(componentRef.hostView);
      this.domElem = (componentRef.hostView as EmbeddedViewRef<any>)
        .rootNodes[0] as HTMLElement;
      document.body.appendChild(this.domElem);
      this.linkUploadModalInstance = componentRef.instance;
    }
    if (this.linkUploadModalInstance) {
      this.linkUploadModalInstance.show();
    }
    // if (this.host && !this.linkUploadModalInstance) {
    //   const componentFactory = this.componentFactoryResolver.resolveComponentFactory(VideoLinkUploadModalComponent);
    //   const viewContainerRef: ViewContainerRef = this.host;
    //   viewContainerRef.clear();
    //   const componentRef = viewContainerRef.createComponent(componentFactory);
    //   this.linkUploadModalInstance = (<VideoLinkUploadModalComponent>componentRef.instance);
    //   this.linkUploadModalInstance.show();
    // }
  }

  onFileUpload(event) {
    this.fileUpload.emit(event);
  }

  onLinkUpload() {
    if (!this.data.name || !this.data.link) {
      swal('Warning', 'Please fill all the fields', 'warning');
      return;
    }

    let validUrl = null;
    try {
      const url = new URL(this.data.link);
      console.log(url);
      validUrl = url.href;
    } catch (err) { validUrl = null; }
    if (!validUrl) {
      swal('Warning', 'Please enter a valid URL', 'warning');
      return;
    }
    this.linkUpload.emit({
      name: this.data.name,
      path: validUrl,
      enc_name: null,
      extension: null
    });
    this.closeLinkUploadModal.nativeElement.click();
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/video-upload-btn/video-upload-btn.component.ts